<!--  -->
<template>
  <div id="transfer" v-if="transferInfo">
    <!-- start::穿梭弹出框 -->
    <el-dialog v-if="transferInfo.buttonSetting" :visible.sync='transferInfo.buttonSetting.visible'
      :title="transferInfo.buttonSetting.modeConf.title||'请为你的穿梭框定义标题'" :top="transferInfo.buttonSetting.top||'5vh'"
      :width="transferInfo.buttonSetting.width||'70%'" :modal="false" :append-to-body="true"
      :before-close="handleTransferButtonClose">
      <el-row :gutter="20">
        <!-- 穿梭框数据表一 -->
        <el-col :span="19" v-if="transferInfo.buttonSetting.modeConf.doubleClick">
          <div class="tableDiv">
            <dataTables ref="dataSourceOne" :tableInfo='transferInfo.dataSourceOne' @getSelected="setToItem"
              @mainTableReload="mainTableReload"></dataTables>
          </div>
        </el-col>
        <div v-else style="height: 470px; overflow-y: auto; margin-left: 20px; margin-right: 20px">
          <el-col>
            <dataTables ref="dataSourceOne" :tableInfo='transferInfo.dataSourceOne' @getSelected="handleOneClick"
              @mainTableReload="mainTableReload"></dataTables>
          </el-col>
        </div>
        <!-- 穿梭框数据表二 -->
        <el-col :span="5" style=" height:400px;" v-if="transferInfo.buttonSetting.modeConf.doubleClick">
          <div style="text-align: left; font-size: 19px">已选择数据：</div>
          <el-form>
            <div style=" height:400px; overflow-y: auto">
              <div v-for="(item,index) in items" :key="item.id" @mouseover="hover(index)" @mouseout="showState = -1">
                <el-form-item class="transfer-form-item" @click.native="handleSelectWidget(index)">
                  {{item.name}}
                  <el-button title="删除" v-show="showState == index" @click.stop="handleTransferItemDelete(index)"
                    class="transfer-action-delete" circle plain type="danger">
                    X
                  </el-button>
                </el-form-item>
              </div>
              <!--<el-button @click="addItems()">add item</el-button>-->
            </div>
          </el-form>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleTransferButtonClose()">关 闭</el-button>
        <el-button type="primary" @click="handleSelectSubmit()">提 交</el-button>
      </span>
    </el-dialog>
    <!-- end::穿梭弹出框 -->
  </div>
</template>

<script>
import dataTables from './internalComponent/easyCrud'
export default {
  components: { dataTables },
  props: ['transferInfo'],
  watch: {
    'transferInfo.buttonSetting.visible': {
      handler(val) {
        if (val === true) {
          this.mainTableReload({ pageSize: 10, pageNum: 1 })
        }
      },
      deep: true
    }

  },
  data() {
    return {
      showState: -1,
      items: [

      ],
      selectRow: {}
    }
  },
  /*mounted: function(params) {
      this.$nextTick(() => {
          console.log('hello transfer')
          console.log(this.$refs)
          this.mainTableReload({pageSize: 10, pageNum: 1})
      })
  },*/
  methods: {
    mainTableReload: function (params) {
      console.log('relaod')
      this.transferInfo.dataSourceOne.table.loading = true
      let JSONCon = {
        orgName: params.orgName,
        loginName: params.loginName,
        name: params.name,
        pageNum: params.pageNum,
        pageSize: params.pageSize,
      }
      this.$http.get(this.transferInfo.buttonSetting.modeConf.urlStr, { params: JSONCon }).then(
        response => {
          //console.log(response)
          this.transferInfo.dataSourceOne.table.loading = false
          if (response.code === 200) {
            // 成功之后的数据
            if (!response.data.records)
              this.transferInfo.dataSourceOne.table.tableData = []
            this.transferInfo.dataSourceOne.table.tableData = response.data.records
            this.transferInfo.dataSourceOne.table.paging.total = response.data.total || response.data.records.length
            return true
          } else {
            this.$message.error(response.msg)
          }
        }
      ).catch(
        error => {
          if (error.msg)
            this.$message.error(error.msg)
          else
            this.$message.error(error.message)
          console.log(this.transferInfo.buttonSetting.modeConf.urlStr)
          this.transferInfo.dataSourceOne.table.loading = false
        }
      )

    },
    handleSelectSubmit() {//提交操作的实现
      if (this.$refs.dataSourceOne.$refs.table.selection.length === 0) {
        this.$message.info('请选择数据后再提交')
        return
      }
      this.$confirm('确认提交？')
        .then(_ => {
          let modeData
          if (this.transferInfo.buttonSetting.modeConf.doubleClick) {//多选就将数据添加到数组中
            modeData = this.items
          } else {//单选就直接返回数据
            modeData = this.selectRow
          }
          this.$refs.dataSourceOne.$refs.table.clearSelection()
          this.items = []
          this.transferInfo.buttonSetting.visible = false
          this.$emit("getModeData", modeData, this.transferInfo.buttonSetting.modeConf.modeProp)
        })
        .catch(_ => { });

    },
    handleTransferButtonClose() {//关闭操作的实现
      this.$refs.dataSourceOne.$refs.table.clearSelection()
      this.items = []
      this.transferInfo.buttonSetting.visible = false
      /** 2020/02/11 ZHJI 修改 */
      // this.$confirm('确认关闭？')
      //     .then(_ => {
      //         this.$refs.dataSourceOne.$refs.table.clearSelection()
      //         this.items = []
      //         this.transferInfo.buttonSetting.visible = false
      //     }).catch(_ => {});
    },
    handleOneClick(selection, row) {

      this.selectRow = row
      console.log('handleOneClikc')
      console.log(selection.length)
      if (this.$refs.dataSourceOne.$refs.table.selection.length === 2) {
        this.$refs.dataSourceOne.$refs.table.selection.splice(0, 1)
      }
      this.selectRow = this.$refs.dataSourceOne.$refs.table.selection[0]
      console.log(this.selectRow)

    },
    setToItem(selection, row) {//监听父组件dataTables的点击表的某一行的事件
      this.items = selection
    },
    hover(index) {//鼠标悬浮的效果
      this.showState = index
    },
    handleTransferItemDelete(index) {//点击选中数据删除按钮执行的操作
      this.$nextTick(() => {
        for (let i = 0; i < this.$refs.dataSourceOne.$refs.table.selection.length; i++) {
          if (this.$refs.dataSourceOne.$refs.table.selection[i].id === this.items[index].id) {
            this.$refs.dataSourceOne.$refs.table.selection.splice(i, 1)
          }
        }
        this.items.splice(index, 1)
      })

    },
    addItems() {
      console.log(this.$refs.dataSourceOne.getRowKeys)
      console.log(this.row)
      console.log(this.$refs.dataSourceOne.getSelectedRows())
      this.items.push({ id: 100, name: 6 })
    },

  }

}

</script>
<style lang='scss' scoped>
$primary-background-color: #ecf8ff;
.transfer-form-item {
  height: 50px;
  font-size: 35px;
  font-weight: bold;
  text-align: left;
  padding-left: 10px;
  margin-bottom: 0px;

  &:hover {
    background: $primary-background-color;
    cursor: move;
  }
}
.transfer-action-delete {
  position: absolute;
  right: 5px;
  top: 5px;
}
.tableDiv {
  overflow-y: auto;
  height: 460px;
}
:deep(.el-dialog) {
  height: 600px;
}

:deep(.el-dialog__body) {
  height: 470px;
  padding-bottom: 1px;
  padding-top: 2px;
}
:deep(th .el-checkbox) {
  display: none;
}
</style>
